import React from 'react';
import { Button, Icon } from 'semantic-ui-react';
import OutboundLink from '../../../atoms/OutboundLink/OutboundLink';
import Modal from '../../../modules/foundation/components/Modal';
import { DASHBOARD_URL } from '../PublishBanner.constants';
import '../style/PublishBanner.css';
var defaultProps = {
  selfService: false
};
export default function InitialModal(_ref) {
  var selfService = _ref.selfService,
    handlePublishOpen = _ref.handlePublishOpen,
    handleRequestOpen = _ref.handleRequestOpen,
    handleInitialClose = _ref.handleInitialClose;
  return /*#__PURE__*/React.createElement(Modal, {
    className: "modal-container initial-modal",
    open: true,
    dimmer: "inverted"
  }, /*#__PURE__*/React.createElement(Modal.Header, null, /*#__PURE__*/React.createElement(Button, {
    id: "inside-close-icon",
    "aria-label": "Close sign up modal",
    className: "inside-close-icon",
    onClick: handleInitialClose,
    icon: true
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "close"
  }))), /*#__PURE__*/React.createElement(Modal.Content, {
    className: "initial-modal-content"
  }, /*#__PURE__*/React.createElement("h2", null, "Click Sign Up to make content edits directly, get a free domain, and take your website live."), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Button, {
    onClick: handlePublishOpen,
    className: "payment-publish-button"
  }, "Sign Up"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: '1em',
      fontSize: '1.25em'
    }
  }, 'Or ', !selfService ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    style: {
      textDecoration: 'underline',
      cursor: 'pointer'
    },
    onClick: handleRequestOpen,
    onKeyDown: handleRequestOpen,
    role: "button",
    tabIndex: "-1"
  }, "Request an Edit"), ' to your website') : /*#__PURE__*/React.createElement(OutboundLink, {
    className: "edit-website-self-service",
    to: DASHBOARD_URL,
    label: "Edit your Website"
  }))));
}
InitialModal.defaultProps = defaultProps;